export default __webpack_public_path__ + "static/Corporate-c7d95a23f735c88e5a186ed981d62321.png";